import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type SeatDto } from '@clients/BusApi';
import { type TripPackageLoaderConfig } from '@itinerary/trip/types';

export enum SeatStatus {
    Empty,
    Female,
    Male,
    NotAvailable,
    NotReservable,
    Wheel,
}

export type Seat = Required<
    Omit<SeatDto, 'status' | 'passengerNationalCode'>
> & {
    icon?: IconDefinition;
    selected?: boolean;
    error?: boolean;
    status: SeatStatus;
};

export interface BusPackageLoaderConfig extends TripPackageLoaderConfig {
    originTerminalId: number;
    destinationTerminalId: number;
    specificProviderId: number | null;
}
